import {useEffect, useMemo} from "react";

import {useStores} from "../../../index";

import ChatWindow from "../ChatWindow/ChatWindow";

import {observer} from "mobx-react-lite";
import {groupMessages} from "../utils";
import {isEmpty} from "lodash";
import { useCookies } from "react-cookie";

const CourseChat = observer(({course, onBack, toggleChat}) => {
    const {user, chat} = useStores();

    const courseChatInfo = chat.courseChatMap[course.id];
    const chatId = courseChatInfo.value?.room?.id;
    const messages = chat.messages[chatId];
    const pendingSocket = chat.pendingMap[chatId];
    const isPending = courseChatInfo.state === 'pending' || (pendingSocket && isEmpty(messages));

    const [tokenCached, setToken, removeToken] = useCookies('access_token');
    const token = tokenCached.access_token

    const handleMessage = (message) => {
        chat.sendMessage(chatId, message);
    }

    const groupedMessages = useMemo(
        () => groupMessages(messages),
        [messages]
    );

    useEffect(() => {
        if (!token || !chatId) return;

        chat.connect({
            chatId,
            accessToken: token,
            userId: user.user.id
        });
    }, [user, chatId]);

    return (
        <ChatWindow
            groupedMessages={groupedMessages}
            isPending={isPending}
            title={course.title}
            onBack={onBack}
            toggleChat={toggleChat}
            onMessage={handleMessage}
        />
    );
})

export default CourseChat;